import {round} from 'lodash'

export const DRILLING_SETTINGS_CANVAS_HEIGHT = 300

type DrawLineOptions = {
  xStart: number
  yStart: number
  xEnd: number
  yEnd: number
  ctx: CanvasRenderingContext2D
  flipY?: boolean
  canvasHeight?: number // Required if flipY is true
  strokeStyle?: string
  lineWidth?: number
}

export function drawLine({
  xStart,
  yStart,
  xEnd,
  yEnd,
  ctx,
  flipY = false,
  canvasHeight = 0
}: DrawLineOptions): void {
  const adjustedYStart = flipY ? canvasHeight - yStart : yStart
  const adjustedYEnd = flipY ? canvasHeight - yEnd : yEnd

  ctx.beginPath()
  ctx.moveTo(xStart, adjustedYStart)
  ctx.lineTo(xEnd, adjustedYEnd)
  ctx.stroke()
}

export function drawDrillingZoneLine({
  ctx,
  zone,
  prevThreshold,
  stepWidth,
  canvasHeight
}: {
  ctx: CanvasRenderingContext2D
  zone: {fromMeter: number; toMeter: number; threshold: number}
  prevThreshold: number | undefined
  stepWidth: number
  canvasHeight: number
}) {
  const xStart = zone.fromMeter * stepWidth
  const xEnd = zone.toMeter * stepWidth
  const heightStep = round(DRILLING_SETTINGS_CANVAS_HEIGHT / canvasHeight, 2)
  const threshold = zone.threshold / heightStep

  if (prevThreshold) {
    const prevAdjusted = prevThreshold / heightStep
    drawLine({
      xStart,
      yStart: prevAdjusted,
      xEnd: xStart,
      yEnd: threshold,
      ctx,
      flipY: true,
      canvasHeight
    })
  }

  drawLine({
    xStart,
    yStart: threshold,
    xEnd,
    yEnd: threshold,
    ctx,
    flipY: true,
    canvasHeight
  })
}

export function drawDrillingZoneLines({
  ctx,
  zones,
  stepWidth,
  canvasHeight
}: {
  ctx: CanvasRenderingContext2D
  zones: Array<{fromMeter: number; toMeter: number; threshold: number}>
  stepWidth: number
  canvasHeight: number
}) {
  let prevThreshold: number | undefined = undefined

  for (const zone of zones) {
    drawDrillingZoneLine({
      ctx,
      zone,
      prevThreshold,
      stepWidth,
      canvasHeight
    })
    prevThreshold = zone.threshold
  }
}
